var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 22",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.954 14.326a4.005 4.005 0 0 0-2.786 1.121l-6.392-3.521a3.704 3.704 0 0 0 0-1.858l6.392-3.521a4.005 4.005 0 0 0 2.786 1.12c2.18 0 3.946-1.722 3.946-3.833C20.9 1.716 19.128 0 16.954 0c-2.55 0-4.45 2.33-3.83 4.766l-6.392 3.52a4.005 4.005 0 0 0-2.786-1.12C1.766 7.166 0 8.888 0 11c0 2.117 1.773 3.834 3.946 3.834a4.005 4.005 0 0 0 2.786-1.12l6.392 3.52C12.504 19.67 14.411 22 16.954 22c2.18 0 3.946-1.722 3.946-3.834 0-2.117-1.766-3.84-3.946-3.84Z"
  })));
};

export default SvgShare;